<div [style.height]="!isInit ? maxHeight + 'px' : 'auto'" [style.overflow]="!isInit ? 'hidden' : 'visible'">
  <div [innerHTML]="content | safeHtml" [class.collapsed]="isCollapsed" [style.height]="isCollapsed ? maxHeight + 'px' : 'auto'" class="auto"></div>
</div>
<a *ngIf="content && isCollapsable" (click)="changeIsCollapsed($event)" class="lire-link">{{ isCollapsed ? '... [Lire plus]' : '[Lire moins]' }}</a>
